import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http'
import {ScholarAuthService}from'./scholar-auth.service'
import { environment } from 'src/environments/environment'
import { of } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ScholarService {
  baseUrl = `${environment.baseUrl}scholar/`
  // baseUrl='http://localhost:4000/mentorship-api/scholar';
  constructor(private httpClient:HttpClient,private scholarAuthService:ScholarAuthService){}
    public register(registrationData){
        return this.httpClient.post(this.baseUrl +'register',registrationData)
    }
    public getAssignedMentorDetails(){
      return this.httpClient.get(this.baseUrl+'assignedMentorDetails/'+this.scholarAuthService.getLoggedUserId())
    }
   public getTaskNotifications(scholarId){
      return this.httpClient.get(this.baseUrl+'taskNotifications/'+ scholarId )
    }
  
}
